import cn from 'classnames';

const LAYER_BASE =
  'max-h-full max-w-full object-contain absolute right-0 bottom-0 left-0 top-1/2 aspect-[4/5] mx-auto overflow-hidden -translate-y-1/2';

const LAYER_IMG = '[&_img]:block [&_img]:h-full [&_img]:w-full [&_img]:object-contain';

const LAYER_SPRITE_IMG =
  '[&_img]:block [&_img]:h-full [&_img]:w-auto [&_img]:object-cover [&_img]:[transform:translateX(var(--sprite-translate-x,0))]';

export const getPreviewLayerClasses = (isActive: boolean, isSprite = false) =>
  cn(LAYER_BASE, isActive ? 'flex' : 'hidden', isSprite ? LAYER_SPRITE_IMG : LAYER_IMG);
